var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDallasCowboysLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 432,
    height: 411,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002244",
    d: "M216,1.28223L348.674,409.61L1.32959,157.25H430.67L83.3264,409.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M216,38.9871L326.511,379.106L37.1892,168.901H394.811L105.489,379.106Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002244",
    d: "M216,68.2722L309.298,355.414L65.0408,177.95H366.959L122.702,355.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDallasCowboysLogo);
export default __webpack_public_path__ + "static/media/dallas-cowboys-logo.92d26aa89cde79aa2ffc2dd028450f58.svg";
export { ForwardRef as ReactComponent };